

import { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { tabController } from '../../Components/utils/functions';

import useWPOptionQuery from './hooks/useWPOptionQuery';

import Settings from './Settings';
import Style from './Style';
import VideoLayout from './VideoLayout';
import { preloader } from './utils/icons';
import { getVideos } from './utils/functions';
import Message from './Components/Message';

const Edit = props => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;
	const { configure } = attributes;
	const { id, orderBy, perPage } = configure;

	useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId 

	useEffect(() => tabController(), [isSelected]);
	const [loading, setLoading] = useState(false);
	const [nextPageToken, setNextPageToken] = useState(null);
	const [videos, setVideos] = useState([]);
	const [error, setError] = useState(null);

	const { data = {}, fetchData, isLoading } = useWPOptionQuery('ytvgb-video-gallery');
	const { key = '' } = data || {};

	const callVideos = () => {
		getVideos(key, attributes, setLoading, nextPageToken, setNextPageToken, setVideos, videos, setError);
	};

	useEffect(() => {
		const settingEvent = () => {
			fetchData();
		}
		window.addEventListener('ytvgbEvent', settingEvent);

		return () => {
			window.removeEventListener('ytvgbEvent', settingEvent);
		}

	}, [isLoading]);//remove isLoading

	useEffect(() => {
		if (key && id) {
			getVideos(key, attributes, setLoading, null, setNextPageToken, setVideos, [], setError);
		}
	}, [key, id, orderBy, perPage]);

	return <>
		<Settings attributes={attributes} setAttributes={setAttributes} callVideos={callVideos} setNextPageToken={setNextPageToken} />

		<div className={className} id={`ytvgbYouTubeVideoGallery-${clientId}`}>
			<Style attributes={attributes} clientId={clientId} />

			<RenderContent attributes={attributes} apiKey={key} callVideos={callVideos} videos={videos} loading={loading} isLoading={isLoading} nextPageToken={nextPageToken} error={error} />
		</div>
	</>;
};
export default Edit;


export const RenderContent = ({ attributes, apiKey, callVideos, videos, loading, isLoading, nextPageToken, error }) => {

	const { id } = attributes.configure;

	// return <h3>nothing to hide</h3>
	// if (loading || isLoading) {
	// 	return <>{preloader}</>
	// }
	// else
	if (!apiKey) {
		return <Message message={__('Please Insert Your Valid YouTube API Key!', 'yt-video-gallery')} type='error' />
	} else if (!id) {
		return <Message message={__('Please Insert Resource ID!', 'yt-video-gallery')} type='error' />
	} else if (error) {
		return <Message message={error} type='error' />
	} else if (isLoading) {
		return <><div className='ytvgbPreloader'>{preloader}</div></>
	} else {
		return <>
			<div className="ytvgbYouTubeVideoGallery">
				<VideoLayout isLoading={loading || isLoading} attributes={attributes} videos={videos} callVideos={callVideos} nextPageToken={nextPageToken} preloader={preloader} />
			</div>
		</>
	}
}